import React, { Component } from "react";
import p5 from "p5";
import P1 from "../assets/image/p1.png"


export default class App extends Component {
    //React ref for div reference we pass into p5
    sketchRef = React.createRef();




    //P5 instance mode
    initSketch = (p) => {
        let canvas;
        // let pg1;
        let p1;

        let w = window.innerWidth;
        let h = window.innerHeight;

        let rw = w * 0.65;


        p.preload = () => {

            p1 = p.loadImage(P1);
        };

        // p.windowResized = () => {

        //     //handle window resize here
        //     window.addEventListener("resize", () => {
        //     p.resizeCanvas(rw, h);
        //     });
        // };

        p.setup = () => {
            //store width and height
            //setup canvas and init values here
            canvas = p.createCanvas(rw, h);
            p.angleMode(p.DEGREES);

            //normal canvas

            p1.resize(50, 0);

        };

        p.draw = () => {
            // reset the drawing position
            // p.translate(-p.width / 2, -p.height / 2);

            let sc = p.second();
            let RC = p.map(sc, 0, 60, 0, 360);

            let mn = 30;
            let RM = p.map(mn, 0, 60, 0, 360);

            let hour = 6;
            let RH = p.map(hour % 12, 0, 12, 0, 360);

            let wave = p.map(p.tan(p.radians(p.frameCount) * 20), -1, 1, 1, 5);

            RH += p.map(mn, 0, 60, 0, 30);

            p.translate(rw / 2, h / 2);
            p.background(0);
            p.rotate(-90);


            p.push();
            p.rotate(RC);
            p.stroke('#83A9F4');
            p.strokeWeight(3);
            p.line(0, 0, rw, 0);
            p.pop();

            p.push();
            p.rotate(RM);
            p.stroke('#ffffff');
            p.strokeWeight(30);
            p.line(0, 0, 500, 0);
            p.pop();

            p.push();
            p.rotate(RH);
            p.stroke('#ffffff');
            p.strokeWeight(30);
            p.line(0, 0, 300, 0);
            p.pop();

            p.push();
            p.blendMode(p.DIFFERENCE);
            p.imageMode(p.CENTER);
            // p.image(p1, 0, 0);
            p.noStroke();
            // p.fill('#7C503C')
            p.ellipse(0, 0, 200 * wave, 200 * wave);
            p.pop();

            p.push();
            // p.noStroke();
            // p.fill(0);
            // p.ellipse(0, 0, 50, 50);
            p.imageMode(p.CENTER);
            p.image(p1, 0, 0);
            p.pop();


            //show the results



        };

        p.windowResized = () => {
            w = window.innerWidth;
            h = window.innerHeight;
            rw = w * 0.65;
            p.resizeCanvas(rw, h);
            //   pg1 = p.createGraphics(rw, h);
            //   pg1.angleMode(p.DEGREES);
        };

    };

    componentDidMount() {
        //Create p5 canvas once component mounts
        this.p5Canvas = new p5(this.initSketch, this.sketchRef.current);
    }

    componentWillUnmount() {
        this.p5Canvas.remove();
        window.removeEventListener('resize', this.windowResized);
    }

    render() {
        //this div will contain the sketch canvas
        return <div className="mySketch" ref={this.sketchRef} />;
    }
}
